// removed by extract-text-webpack-plugin
module.exports = {"footerContainer":"Footer__footerContainer___gODu9","button":"Footer__button___1DcNz","footerInBigScreen":"Footer__footerInBigScreen___2b19s","footerInSmallScreen":"Footer__footerInSmallScreen___2JYh2","footerBorderInSmall":"Footer__footerBorderInSmall___2f0Fh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Footer.scss
// module id = 1490
// module chunks = 0